import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { CheckThickIcon } from '@fiverr-private/icons';
import { white } from '@fiverr-private/sass/helpers/index';
import { renderChildren } from '@fiverr-private/ui_utils';
import { CheckboxProps } from './types';
import classes from './index.module.scss';

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      children,
      className: customClassName,
      disabled = false,
      disableCheckmarkMargin = false,
      isError = false,
      ...rest
    },
    ref
  ) => {
    const className = classnames(
      classes.checkboxContainer,
      {
        [classes.disabled]: disabled,
        [classes.isError]: isError,
      },
      customClassName
    );

    const boxClasses = classnames(classes.checkmarkBox, { [classes.disableCheckmarkMargin]: disableCheckmarkMargin });

    const inputProps = {
      type: 'checkbox',
      disabled,
      ref,
      ...rest,
    };

    return (
      <label htmlFor={rest.id} className={className}>
        <input role="checkbox" {...inputProps} />
        <span className={boxClasses}>
          <CheckThickIcon color={white} size={12} />
        </span>
        {renderChildren(children)}
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
